import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';


import { Urls } from 'constants/constants';

import User from 'store/models/User';

import StyleGuide from 'screens/StyleGuide';
import HomeScreen from 'screens/HomeScreen';

import Brands from 'screens/Brands';
import CampaignEdit from 'screens/CampaignEdit';
import CampaignDetails from 'screens/CampaignDetails';
import SlideshowEdit from 'screens/SlideshowEdit';
import OverlayRedirect from 'screens/OverlayRedirect';
import AuthSuccess from 'screens/AuthSuccess';
import AccountSettings from 'screens/AccountSettings';
import LinkEdit from 'screens/LinkEdit';
import Links from 'screens/Links';
import Slides from 'screens/Slides';
import Media from 'screens/Media';
import Channels from 'screens/Channels';
import ChannelSettings from 'screens/ChannelSettings';
import ChannelDetails from 'screens/ChannelDetails';
import Streams from 'screens/Streams';
import StreamDetails from 'screens/StreamDetails';
import ChatSettings from 'screens/ChatSettings';
import ResetPassword from 'screens/ResetPassword';
 

export const ProtectedRoutes = ({ children }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      dispatch(User.actions.checkLogin());
    })();
  }, [])
  return children;
}



function Routes(props) {
  return (
    <>
      <Switch>
        <Route exact path={Urls.HOME} component={HomeScreen} />

        <Route exact path={Urls.OAUTH_SUCCESS} component={AuthSuccess} />
        <Route path={Urls.RESET_PASSWORD} component={ResetPassword} />
        <Route exact path="/styleguide" component={StyleGuide} />
        
        <ProtectedRoutes>
          <Switch>
            <Route exact path={Urls.DASHBOARD}>
              <Redirect to={Urls.CHANNELS} />
            </Route>

            <Route path="/dashboard/overlay/:id/channel/:channelId" component={ChannelDetails} />
            
            <Route exact path={Urls.CAMPAIGNS} component={Brands} />
            <Route exact path={Urls.CAMPAIGN_NEW_ROUTE} component={CampaignEdit} />
            <Route path={Urls.CAMPAIGN_EDIT_ROUTE} component={CampaignEdit} />
            <Route path={Urls.CAMPAIGN_DETAILS_ROUTE} component={CampaignDetails} />
            
            <Route exact path={Urls.CHANNELS} component={Channels} />
            <Route exact path={Urls.CHANNEL_SETTINGS_ROUTE} component={ChannelSettings} />
            <Route exact path={Urls.CHANNEL_DETAILS_ROUTE} component={ChannelDetails} />

            <Route exact path={Urls.STREAMS} component={Streams} />
            <Route exact path={Urls.STREAM_DETAILS_ROUTE} component={StreamDetails} />
            
            <Route exact path={Urls.MEDIA} component={Media} />
            
            <Route path={Urls.LINK_NEW} component={LinkEdit} />
            <Route path={Urls.LINK_EDIT_ROUTE} component={LinkEdit} />
            <Route exact path={Urls.LINKS} component={Links} />

            <Route exact path={Urls.SLIDESHOW} component={OverlayRedirect} />
            <Route path={Urls.SLIDESHOW_CREATE} component={SlideshowEdit} />
            <Route path={Urls.SLIDESHOW_EDIT_OVERLAY_ROUTE} component={SlideshowEdit} />
            <Route path={Urls.SLIDESHOW_EDIT_ROUTE} component={SlideshowEdit} />
            <Route exact path={Urls.SLIDES} component={Slides} />
            
            <Route exact path={Urls.CHAT} component={ChatSettings} />

            <Route exact path={Urls.ACCOUNT_SETTINGS} component={AccountSettings} />
          </Switch>
        </ProtectedRoutes>
      </Switch>
    </>);
 }

 export default Routes;